import getSniff from '../utils/getSniff';
import isNode from '../utils/isNode';

export default (ctx) => {
    ctx.commonData = {};
    const ua = !isNode ? navigator.userAgent : ctx.req.headers['user-agent'];
    const sniff = getSniff(ua);

    ctx.commonData.sniff = sniff;
};
